import { useStreamChannelStore } from '../stores/useStreamChannelStore';

const noop = () => {
  return;
};

/**
 * 스트림 연결 제어 훅
 * @description
 * - 스트림 연결/해제 함수와 연결 상태를 반환합니다.
 * - 스트림 채널 구독 로직과 분리된 제어 전용 훅입니다.
 * @example
 * const { isConnected, connect, disconnect } = useStreamControl();
 */
const useStreamControl = () => {
  const connect = useStreamChannelStore(state => state.connect);
  const disconnect = useStreamChannelStore(state => state.disconnect);
  const isConnected = useStreamChannelStore(state => state.isConnected);
  const connectedCount = useStreamChannelStore(state => state.count);
  const isConnectionLost = isConnected === false && connectedCount > 0;

  return {
    connect: connect ?? noop,
    disconnect: disconnect ?? noop,
    isConnected,
    isConnectionLost,
    connectedCount,
  };
};

export default useStreamControl;
